import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { alertListMapping } from '../../../assets/data/enum/alertListMapping';

@Injectable()
export class MappingService {
  public list = new BehaviorSubject<any>(null);

  constructor() {
    this.list.next(alertListMapping);
  }
  /*
		getList = (): Observable<any> => {
			return new Observable((observer) => {
							this.list.next(alertListMapping);
							observer.next(alertListMapping);
							observer.complete();
			});
		} */
}
